import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthApi, JwtAuthenticatedApi, PublicApi } from '../api-definition'
import { config } from '../config'

export const AuthenticatedApiClient = generateApiClient(config.apiName, AuthApi.routes)
export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
export const PublicApiClient = generateApiClient(config.apiName, PublicApi.routes)
export const JwtAuthenticatedApiClient = generateApiClient(config.apiName, JwtAuthenticatedApi.routes)
